/**
 * API Configuration
 */

export const API_CONFIG = {
  /** Base URL for the API (relative to app root) */
  BASE_URL: '/api',

  /** Presets API endpoints */
  ENDPOINTS: {
    PRESETS: '/presets/'
  },

  /** Request timeout in milliseconds */
  TIMEOUT: 10000,

  /** Number of retry attempts for failed requests */
  RETRY_ATTEMPTS: 2,

  /** Delay between retries in milliseconds */
  RETRY_DELAY: 500
} as const;

/**
 * Storage mode for presets
 */
export type StorageMode = 'server' | 'local' | 'mixed';

export const STORAGE_MODE = {
  SERVER: 'server' as StorageMode,
  LOCAL: 'local' as StorageMode,
  MIXED: 'mixed' as StorageMode
} as const;
